import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export type FeishuMessageType = 'contact' | 'blog' | 'project' | 'test';

export interface FeishuNotifyRequest {
  type: FeishuMessageType;
  data: Record<string, unknown>;
}

export interface FeishuNotifyResponse {
  success: boolean;
  message?: string;
  error?: string;
}

async function sendFeishuNotification(request: FeishuNotifyRequest): Promise<FeishuNotifyResponse> {
  const { data, error } = await supabase.functions.invoke('feishu-notify', {
    body: request,
  });

  if (error) {
    throw new Error(error.message || 'Failed to send notification');
  }

  return data as FeishuNotifyResponse;
}

export function useFeishuNotify() {
  return useMutation({
    mutationFn: sendFeishuNotification,
    onSuccess: (data) => {
      if (data.success) {
        toast.success('通知发送成功');
      }
    },
    onError: (error: Error) => {
      console.error('Feishu notification error:', error);
      toast.error(`通知发送失败: ${error.message}`);
    },
  });
}

export function useFeishuTestNotify() {
  return useMutation({
    mutationFn: () => sendFeishuNotification({ type: 'test', data: {} }),
    onSuccess: (data) => {
      if (data.success) {
        toast.success('测试消息发送成功！请检查飞书群');
      }
    },
    onError: (error: Error) => {
      console.error('Feishu test error:', error);
      toast.error(`测试失败: ${error.message}`);
    },
  });
}
